import React, { useState, useEffect } from "react";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { FaCarSide, FaStar, FaShieldAlt, FaCalendarCheck, FaTrophy, FaClock } from "react-icons/fa";

const services = [
  { icon: <FaCarSide />, text: "Fixed Rates" },
  { icon: <FaStar />, text: "Quality Vehicles" },
  { icon: <FaCalendarCheck />, text: "Pre Booking" },
  { icon: <FaShieldAlt />, text: "Reliable Transfers" },
  { icon: <FaTrophy />, text: "Award Winning" },
  { icon: <FaClock />, text: "24/7 Services" },
];

export default function AboutUs() {
  const [isMobile, setIsMobile] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [clickedButton, setClickedButton] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Ocultar el componente si es un dispositivo móvil
  if (isMobile) {
    return <></>;
  }

  const handleMouseEnter = (index) => setHoveredIndex(index);
  const handleMouseLeave = () => setHoveredIndex(null);

  const handleButtonHover = (button) => setHoveredButton(button);
  const handleButtonLeave = () => setHoveredButton(null);

  const handleButtonClick = (button) => {
    setClickedButton(button);
    setTimeout(() => setClickedButton(null), 200);
  };

  return (
    <div style={styles.container}>
      <div style={styles.buttonContainer}>
        <button
          style={{
            ...styles.button,
            ...(clickedButton === "quote" ? styles.buttonClicked : {}),
            ...(hoveredButton === "quote" ? styles.buttonHover : {}),
          }}
          onMouseEnter={() => handleButtonHover("quote")}
          onMouseLeave={handleButtonLeave}
          onClick={() => {
            handleButtonClick("quote");
            window.location.href = "http://localhost:3000/reservations";
          }}
        >
          <FaEnvelope style={styles.icon} />
          Book Now or Custom Quote!
        </button>

        <button
          style={{
            ...styles.button,
            ...(clickedButton === "call" ? styles.buttonClicked : {}),
            ...(hoveredButton === "call" ? styles.buttonHover : {}),
          }}
          onMouseEnter={() => handleButtonHover("call")}
          onMouseLeave={handleButtonLeave}
          onClick={() => {
            handleButtonClick("call");
            window.location.href = "tel:19149628444";
          }}
        >
          <FaPhoneAlt style={styles.icon} />
          Call Now: 1914 9628444
        </button>
      </div>

      <div style={styles.mainSection}>
        <div style={styles.leftSection}>
          <h2 style={styles.subtitle}>OUR COMPANY</h2>
          <h1 style={styles.title}>
            We Provide Luxury <span style={styles.boldText}>Limousine and Car Service</span>
          </h1>
          <p style={styles.subDescription}>
            in Westchester County, Dutchess County, Putnam County, Orange County, Fairfield County.
          </p>
        </div>

        <div style={styles.rightSection}>
          <p style={styles.description}>
            Jet Black Limo specializes in providing luxury transportation services across the region of New York, covering key cities and towns, ensuring comfortable and safe travel.
          </p>
          <p style={styles.description}>
            We offer efficient transfers to and from major nearby airports, including JFK, LaGuardia (LGA), Newark (EWR), Westchester County Airport (HPN), Bradley Airport, New York City, and other key locations.
          </p>
          <p style={styles.description}>
            Our fleet of luxury vehicles, combined with professional chauffeurs, ensures punctual service for events, corporate meetings, weddings, and long-distance travel.
          </p>
        </div>
      </div>

      <div style={styles.cardsRow}>
        {services.map((service, index) => (
          <div
            key={index}
            style={{
              ...styles.card,
              ...(hoveredIndex === index ? styles.cardHover : {}),
            }}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div
              style={{
                ...styles.iconWrapper,
                ...(hoveredIndex === index ? styles.iconWrapperHover : {}),
              }}
            >
              <div
                style={{
                  ...styles.icon,
                  ...(hoveredIndex === index ? styles.iconHover : {}),
                }}
              >
                {service.icon}
              </div>
            </div>
            <p style={hoveredIndex === index ? styles.cardTextHover : styles.cardText}>
              {service.text}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "60px 20px",
    fontFamily: "'Merriweather', serif",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "40px",
  },
  button: {
    backgroundColor: "#000",
    color: "#fff",
    padding: "15px 25px",
    border: "none",
    borderRadius: "10px",
    fontSize: "1rem",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
    cursor: "pointer",
    transition: "background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease",
  },
  buttonHover: {
    backgroundColor: "#000",
    color: "#fff",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.9)",
    transform: "translateY(-5px)",
    fontWeight: "900",
  },
  buttonClicked: {
    backgroundColor: "#333",
    transform: "scale(0.98)",
  },
  icon: {
    fontSize: "1.5rem",
  },
  mainSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    maxWidth: "1200px",
    margin: "0 auto",
    gap: "60px",
  },
  leftSection: {
    flex: 1,
    paddingRight: "40px",
  },
  rightSection: {
    flex: 1,
    textAlign: "justify",
  },
  subtitle: {
    color: "#000",
    fontSize: "1.5rem",
    fontWeight: "bold",
    fontFamily: "'Playfair Display', serif",
    marginBottom: "10px",
  },
  title: {
    fontSize: "2.5rem",
    color: "#2a2a2a",
    fontWeight: "bold",
    lineHeight: "1.2",
    marginBottom: "10px",
  },
  boldText: {
    fontWeight: "bold",
    color: "#000",
  },
  subDescription: {
    fontSize: "1.3rem",
    color: "#495057",
    marginTop: "10px",
  },
  description: {
    fontSize: "1.2rem",
    color: "#495057",
    lineHeight: "1.8",
    marginBottom: "15px",
  },
  cardsRow: {
    display: "flex",
    justifyContent: "space-around",
    gap: "20px",
    marginTop: "40px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  card: {
    padding: "40px",
    borderRadius: "10px",
    textAlign: "center",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease",
    cursor: "pointer",
    width: "250px",
  },
  cardHover: {
    transform: "translateY(-10px)",
    backgroundColor: "#000",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.3)",
  },
  iconWrapper: {
    width: "80px",
    height: "80px",
    border: "2px solid #000",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "10px",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease, border-color 0.3s ease",
  },
  iconWrapperHover: {
    backgroundColor: "#000",
    borderColor: "#fff",
  },
  cardText: {
    fontSize: "1.1rem",
    color: "#000",
    margin: 0,
    transition: "color 0.3s ease",
  },
  cardTextHover: {
    color: "#fff",
    margin: 0,
  },
};

